module.exports = __webpack_public_path__ + "img/q.3788bb63.jpg";